import React from 'react';
import { DateUtils } from '@vectord/utils';
import pluralize from 'pluralize';

import { LearnerInfoPopover } from 'features/courseResume';
import CancelButton from '../CancelButton';
import EditDurationButton from '../EditDurationButton';
import styles from './ApprovedTableRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';
import ViewButton from '../ViewButton';

function ApprovedTableRow({ request }) {
  const {
    duration_of_pause: durationOfPause,
    pause_date: pauseDate,
    note,
    meta,
  } = request;
  const { suggested_sb_name: suggestedSuperBatchName } = meta || {};

  return (
    <TableRow className={styles.root}>
      <TableCell className={styles.rowCell}>
        <LearnerInfoPopover request={request} />
      </TableCell>
      <TableCell className={styles.rowCell}>
        {DateUtils.toDDMMYYYY(pauseDate)}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {pluralize('Month', durationOfPause, true)}
      </TableCell>
      <TableCell className={styles.rowCell}>
        {suggestedSuperBatchName || 'N/A'}
      </TableCell>
      <TableCell className={styles.rowCell}>
        <div className={styles.noteContainer}>{note?.content || 'N/A'}</div>
      </TableCell>
      <TableCell className={styles.actionCell}>
        <ViewButton request={request} />
      </TableCell>
      <TableCell className={styles.actionCell}>
        <EditDurationButton request={request} />
      </TableCell>
      <TableCell className={styles.actionCell}>
        <CancelButton request={request} />
      </TableCell>
    </TableRow>
  );
}

export default ApprovedTableRow;
